module.exports = __webpack_public_path__ + "static/media/photo.927ca1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photo.jpg
// module id = 234
// module chunks = 0